import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Grid, Icon, Progress } from 'semantic-ui-react';
import StlUploadToS3 from '../processes/stlUploadToS3'
import styles from './modelProgress.module.css';

class ModelProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            segmentationLable: "Wait while our machine learning algorithms perform some number crunching and prepare the results!",
            firstViewerStarted: false,
            secondViewerStarted: false,
            urn1: '',
            urn2: ''
        };
        this.segmentation_Started = false
        this.isComponentMounted = false

        this.emulatorIndex = 0
        this.emulateWorkFlowsInterval = null
    }

    componentWillUnmount() {
        this.segmentation_Started = false
        this.isComponentMounted = false

        this.emulatorIndex = 0
        this.emulateWorkFlowsInterval = null

        this.setState({
            segmentationLable: "Wait while our machine learning algorithms perform some number crunching and prepare the results!",
            firstViewerStarted: false,
            secondViewerStarted: false,
            urn1: '',
            urn2: ''
        })
    }

    onRecievedUrn(response) {
        // console.log("onRecievedUrn : ", response)
        if (!this.state.firstViewerStarted) {
            this.props.startFirstViewer(response)
            this.setState({
                firstViewerStarted: true
            })
        }
        else if (!this.state.secondViewerStarted) {
            this.setState({
                secondViewerStarted: true
            })
            this.props.readyForSecondViewer(response)
        }
    }

    onSubmitJobCallback(data) {
        if (this.isComponentMounted) {
            if (data.body.type === "progress") {
                // console.log("### inprogress : ", data.body.process, data.body.progress)
                if (data.body.status === "completed") {
                    this.progressRenderer(data.body, true, false)
                } else if (data.body.status === "failed") {
                    this.progressRenderer(data.body, false, true)
                } else {
                    this.progressRenderer(data.body, false, false)
                }
            }
            else if (data.body.type === "data") {
                // console.log("### received data : ", data.body.data)
                this.onRecievedUrn(data.body.data)
            }
        }
    }

    progressRenderer(body, isProcessComplete, failed) {
        let ele = this.refs.segmentation_progress
        if (body.process !== 'received_msg' && !failed) {
            // console.log('starting with first process : ', process)
            this.startingSegmentation(body.process)
            if (ele !== null) {
                if (!isProcessComplete) {
                    ReactDOM.render(
                        <div>
                            <div className={'ui small header'}>
                                {this.state.segmentationLable}
                            </div>
                            <Progress percent={body.progress} color='blue' active progress>Working ...</Progress>
                        </div>, ele)
                }
                else {
                    ReactDOM.render(
                        <div>
                            <div className={'ui small header'}>
                                {this.state.segmentationLable}
                            </div>
                            <Progress percent={body.progress} color='blue' active progress>All done</Progress>
                        </div>, ele)
                }
            }
        }
        else {
            // console.log("some logic missing !!")
            if (failed) {
                ReactDOM.render(
                    <div>
                        <div className={'ui small header'}>
                            {this.state.segmentationLable}
                        </div>
                        <Progress percent={100} error>There was an error</Progress>
                    </div>, ele)
            }
            this.startingSegmentation(body.process)
        }

    }

    startingSegmentation(process) {
        let ele
        if (process === 'received_msg') {
            ele = this.refs.starting_Seg
            ReactDOM.render(            
                <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                    <div className={"ui small header font-weight-bold"}>
                        Mesh Segmentation
                    </div>                    
                </div>, ele)
        }
        else if (!this.segmentation_Started) {
            ele = this.refs.starting_Seg
            ReactDOM.render(            
            <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                 <div className={"ui small header font-weight-bold"}>
                    Mesh Segmentation
                </div>
            </div>, ele)

            this.segmentation_Started = true
        }
    }

    emulateWorkFlows() {
        // console.log('Emulating Wrokflow !!! ')
        let data = null
        switch (this.emulatorIndex) {
            case 0:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "submitted", "process": "received_msg", "progress": 0 } }
                this.onSubmitJobCallback(data)
                break;

            case 1:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "download_stl", "progress": 5 } }
                this.onSubmitJobCallback(data)
                break;

            case 2:
                data = {
                    "action": "submit-job", "body": {
                        "type": "data", "status": "completed", "process": "create_viewables_input_stl",
                        "data": { "urn": this.state.urn1 }
                    }
                }
                this.onSubmitJobCallback(data)
                break;

            case 3:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "generate_data", "progress": 25 } }
                this.onSubmitJobCallback(data)
                break;

            case 4:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "run_prediction", "progress": 45 } }
                this.onSubmitJobCallback(data)
                break;

            case 5:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "run_prediction", "progress": 65 } }
                this.onSubmitJobCallback(data)
                break;

            case 6:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "run_prediction", "progress": 85 } }
                this.onSubmitJobCallback(data)
                break;

            case 7:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "patch_generation", "progress": 90 } }
                this.onSubmitJobCallback(data)
                break;

            case 8:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "running", "process": "upload_results", "progress": 95 } }
                this.onSubmitJobCallback(data)
                break;

            case 9:
                data = {
                    "action": "submit-job", "body": {
                        "type": "data", "status": "completed", "process": "create_viewables_input_stl",
                        "data": { "urn": this.state.urn2 }
                    }
                }
                this.onSubmitJobCallback(data)
                break;

            case 10:
                data = { "action": "submit-job", "body": { "type": "progress", "status": "completed", "process": "job_done", "progress": 100 } }
                this.onSubmitJobCallback(data)
                break;

            default:
                // console.log("clearing the interval of emulator.")
                clearInterval(this.emulateWorkFlowsInterval);
                break;
        }

        this.emulatorIndex = this.emulatorIndex + 1
    }

    onStlUploadDone(response) {
        if (this.props.parentState.isCreateNew) {
            let sendData = { "action": "submit-job", "body": { "UID": response.s3ObjUID } }
            this.props.webSocketClient.run(sendData, this.onSubmitJobCallback.bind(this))
        }
        else {
            let uid = this.props.geomId;
            this.setState({
                urn1: btoa(`urn:adsk.objects:os.object:${process.env.REACT_APP_ADSK_BUCKET}/ml-mesh-seg_${uid}_input.zip`),
                urn2: btoa(`urn:adsk.objects:os.object:${process.env.REACT_APP_ADSK_BUCKET}/ml-mesh-seg_${uid}_output.zip`)
            })
            this.emulateWorkFlowsInterval = setInterval(this.emulateWorkFlows.bind(this), 200);
        }
    }

    startStlUpload() {
        // console.log('WebSocket is connected. in model process')
        let ele = this.refs.stlUploadToS3
        ReactDOM.render(<StlUploadToS3 parentState={this.props.parentState}
            onStlUploadDone={this.onStlUploadDone.bind(this)}
            geomId={this.props.geomId}
            webSocketClient={this.props.webSocketClient}></StlUploadToS3>, ele)
    }

    componentDidMount() {
        // console.log("model progress loaded !!!");
        this.isComponentMounted = true;
        this.startStlUpload();
    }

    render() {

        return (
            <Grid columns={1} className={'shbg-pallet white no-padding no-margin'} >
                <Grid.Column>
                    <Grid.Row>
                        <div ref="stlUploadToS3"></div>
                    </Grid.Row>
                    <Grid.Row>
                        <div ref="starting_Seg"></div>                        
                    </Grid.Row>
                    <Grid.Row>
                        <div ref="segmentation_progress"></div>
                    </Grid.Row>
                </Grid.Column>
            </Grid >
        );
    }
}

export default ModelProgress;